import { useEffect, useState } from 'react'
import { platform } from '@/platform'

/** Offline is a different message from "save failed". Saying "something went
 *  wrong" for both teaches the doctor to distrust the app. */
export function useOnlineStatus(): boolean {
  const [online, setOnline] = useState(() => platform.network.isOnline())
  useEffect(() => platform.network.onChange(setOnline), [])
  return online
}
